import { useEffect } from 'react';
import { buildQueryString, getQueryParams } from '@lingoda/urls';
import { getStorageValue, removeStorageValue, setStorageValue } from '@lingoda/utils';
import useLocation from './useLocation';
import useHistory from './useHistory';

export enum QueryFlag {
    showYearlyRecap = 'showYearlyRecap',
}

const queryPersistentFlags = [QueryFlag.showYearlyRecap];

export const useQueryFlagsStore = () => {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const allQueryParams = getQueryParams(location.search);
        const enabledQueryFlags = Object.keys(allQueryParams).filter((key): key is QueryFlag =>
            queryPersistentFlags.includes(key as QueryFlag),
        );
        if (!enabledQueryFlags.length) {
            return;
        }

        enabledQueryFlags.forEach((flag) => {
            setStorageValue(getStorageKey(flag), true);
        });
        const restQueryParams = Object.fromEntries(
            Object.entries(allQueryParams).filter(
                ([key]) => !enabledQueryFlags.includes(key as QueryFlag),
            ),
        );
        history.replace({
            ...location,
            search: buildQueryString(restQueryParams),
        });
        // Run this effect only once since there's no need to listen to location changes
        // Query flags are supposed to be set externally
        // Use initial values of history & location dependencies
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export const getQueryFlag = (flag: QueryFlag) => {
    return getStorageValue(getStorageKey(flag));
};

export const clearQueryFlag = (flag: QueryFlag) => {
    removeStorageValue(getStorageKey(flag));
};

const getStorageKey = (flag: QueryFlag) => `lingodaQueryFlag_${flag}`;
